import { Template } from "../../../template/index";
import { Component } from "../../../view/index";
import ListView from "../index";


export default class ListViewItem extends Component
{
    public readonly id: number;

    public template = Template.lazy('/core/component/listView/item/index.html');
    public data: ListViewItemData;
    public readonly listView: ListView;

    constructor(listView: ListView, data?: ListViewItemData)
    {
        super(data);
        this.listView = listView;
        this.id = this.listView.nextItemId;
    }
}

export interface ListViewItemConstructor
{
    new (listView: ListView, data?: ListViewItemData): ListViewItem
}

export interface ListViewItemData
{
    
}
